import { Filter } from "./Filter";
import { ColorEffect2D } from "../display/effect2d/ColorEffect2D";
import { ClassUtils } from "../utils/ClassUtils";
import { SerializeUtil } from "../loaders/SerializeUtil";
export class ColorFilter extends Filter {
    getEffect() {
        return this._effect2D;
    }
    constructor(mat = null) {
        super();
        this._effect2D = new ColorEffect2D(mat);
    }
    gray() {
        this._effect2D.gray();
        return this;
    }
    color(red = 0, green = 0, blue = 0, alpha = 1) {
        this._effect2D.color(red, green, blue, alpha);
        return this;
    }
    setColor(color) {
        this._effect2D.setColor(color);
        return this;
    }
    setByMatrix(matrix) {
        this._effect2D.setByMatrix(matrix);
        this.onChange();
        return this;
    }
    adjustColor(brightness, contrast, saturation, hue) {
        this._effect2D.adjustColor(brightness, contrast, saturation, hue);
        return this;
    }
    adjustBrightness(brightness) {
        this._effect2D.adjustBrightness(brightness);
        return this;
    }
    adjustContrast(contrast) {
        this._effect2D.adjustContrast(contrast);
        return this;
    }
    adjustSaturation(saturation) {
        this._effect2D.adjustSaturation(saturation);
        return this;
    }
    adjustHue(hue) {
        this._effect2D.adjustHue(hue);
        return this;
    }
    reset() {
        this._effect2D.reset();
        return this;
    }
    onAfterDeserialize() {
        if (SerializeUtil.hasProp("_color"))
            this.setColor(this._color);
        if (SerializeUtil.hasProp("_brightness", "_contrast", "_saturation", "_hue"))
            this.adjustColor(this._brightness || 0, this._contrast || 0, this._saturation || 0, this._hue || 0);
    }
}
ClassUtils.regClass("ColorFilter", ColorFilter);
